const defaultState: ModelState<any, string> = {
  isLoading: false,
  error: null,
  oneEntity: null,
  listOfEntities: [],
  allEntities: [],
  isOneOutdated: false,
  isListOutdated: false,
  areAllOutdated: false,
  areAllLoading: false,
};

export default defaultState;
